import { useEffect } from 'react';
import { UserButton, useUser } from '@clerk/clerk-react';
import { useReducer } from 'react';
import { Helmet } from 'react-helmet';
import Reducer from '../../../services/Reducer';
import { Avatar } from '@mui/material';
import { CallWithAuth } from '../../../actions/apiAction';
import { CHAT_URL, CUSTOMER_PORTAL_URL, GET_SUBSCRIBED_CREATOR, USER_LIST } from '../../../utils/apiUrl';
import Cookie from '../../../utils/Cookie';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import toast from 'react-hot-toast';
import Loader from '../../../utils/Loader';
import LoadingScreen from '../../../components/LoadingScreen';
import PageLoader from '../../../components/PageLoader';
const initState = {
    userList: '',
    loading: false,
};
const AccountSetting = () => {
    const { user } = useUser();
    const [state, dispatch] = useReducer(Reducer, initState);
    const navigator = useNavigate();

    const getUserList = async () => {
        dispatch({ type: "SETDATA", payload: { name: "loading", value: true } });

        let response = await CallWithAuth("GET", GET_SUBSCRIBED_CREATOR);
        if (response.data) {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: response?.data } });
        } else {
            dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
            dispatch({ type: "SETDATA", payload: { name: "userList", value: [] } });

        }
        dispatch({ type: "SETDATA", payload: { name: "loading", value: false } });
    };
    const customerPortalPreview = async () => {
        const newWindow = window.open('', '_blank');
        const response = await CallWithAuth("GET", CUSTOMER_PORTAL_URL);
        if (response?.data && response?.data?.portal_url) {
            newWindow.location.href = response?.data?.portal_url;
        } else {
            newWindow.close();
            toast.error(response?.data?.detail)
        }
    }

    useEffect(() => {
        getUserList();
    }, []);
    return (
        <>
            <Helmet>
                <title>Account | TLK</title>
            </Helmet>
            {/* start: Account AccountSetting page */}
            <div className="min-h-screen gradient-bg-1 p-6">
                <div className="flex items-center gap-4 mb-8">
                    <button className="text-foreground/70 hover:text-foreground transition-colors"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#af0056"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-xl font-bold heading-text">Account Settings</h1>
                </div>
                <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>

                    <div
                        className="background-highlight rounded-2xl p-4  mb-6"
                        style={{
                            opacity: 1, transform: "none"
                        }}
                    >
                        <p className="text-xs text-white mb-3">Subscriptions</p>
                        <div className="flex flex-col gap-y-2">
                            {
                                state?.loading ?
                                    <PageLoader />
                                    :
                                    !state?.loading && state.userList && state.userList?.length > 0 ?
                                        state.userList?.map((item, index) => {
                                            return (
                                                <div className="flex items-center gap-3" key={item?.subscription_id}>
                                                    <Avatar alt="Remy Sharp" src={item?.creator_profile_picture_url}>{item?.creator_name?.charAt(0)}</Avatar>
                                                    <div className="flex-1">
                                                        <h3 className="font-semibold text-white">{item?.creator_name}</h3>
                                                        <p className="text-xs text-muted-white">Member since {moment(item?.member_since).format('MMM YYYY')}</p>
                                                        {/* {item?.subscription_plan && <div className="flex items-center gap-1 mt-1">
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width={24}
                                                                height={24}
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="#af0056"
                                                                strokeWidth={2}
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                className="lucide lucide-crown w-3 h-3 text-primary"
                                                            >
                                                                <path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z" />
                                                                <path d="M5 21h14" />
                                                            </svg>
                                                            <span className="text-xs text-primary font-medium">
                                                                {item?.subscription_plan?.name} Member
                                                            </span>
                                                        </div>} */}
                                                    </div>
                                                    <button className="text-white text-sm font-medium"
                                                        onClick={() => navigator(`/user/billing-history?creator_id=${item?.creator_id}`)}
                                                    >Manage</button>
                                                </div>
                                            )
                                        }) :

                                        <p className="text-sm text-muted-foreground">No Creator Subscribed yet</p>
                            }
                        </div>

                    </div>

                </div>
            </div>

            {/* end: Account AccountSetting page */}
        </>
    );
}

export default AccountSetting;
